import { compose, pure, withHandlers } from "recompose";

import { FIXED2 } from "../../../tools/fixedTools";
import PaymentAffectationForm from "./PaymentAffectationForm";
// import Queries from "../../../queries/queries";
import Queries from "../../../queries/queries2";
import React from "react";
import Spinner from "../../../elements/Spinner/Spinner";
import _ from "lodash-es";
import { fixDateFromDataBase } from "../../../tools/formatDate";
import { graphql } from "react-apollo";
import linesUpdate from "../../../tools/linesUpdate";

const query = graphql(Queries.GET_BANK_TRANSACTION, {
  name: "getBankTransactionQuery",
  options: {
    fetchPolicy: "cache-and-network"
  }
});

const createLineMutation = graphql(
  Queries.CREATE_BANK_TRANSACTION_LINE_MUTATION,
  { name: "createBankTransactionLines" }
);

const createLineMutationWithoutTiersId = graphql(
  Queries.CREATE_BANK_TRANSACTION_LINE_WITHOUT_TIERSID_MUTATION,
  { name: "createBankTransactionLinesWithoutTiersId" }
);

const deleteLineMutation = graphql(
  Queries.DELETE_BANK_TRANSACTION_LINE_MUTATION,
  { name: "deleteBankTransactionLines" }
);

const updateLineMutation = graphql(
  Queries.UPDATE_BANK_TRANSACTION_LINE_MUTATION,
  { name: "updateBankTransactionLines" }
);

class InvalidTiersError extends Error {
  constructor(...params) {
    console.log(params);
    // Passer les arguments restants (incluant ceux spécifiques au vendeur) au constructeur parent
    super(...params);

    // Maintenir dans la pile une trace adéquate de l'endroit où l'erreur a été déclenchée (disponible seulement en V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, InvalidTiersError);
    }

    // Informations de déboguage personnalisées
    // this.errorLines = errorLines;
    if (params[0].amount !== undefined) {
      this.amount = params[0].amount;
    }

    if (params[0].errorLines !== undefined) {
      this.errorLines = params[0].errorLines;
    }
  }
}
const saveLinesHandler = withHandlers({
  saveLines: ({
    updateBankTransaction,
    createBankTransactionLines,
    createBankTransactionLinesWithoutTiersId,
    deleteBankTransactionLines,
    updateBankTransactionLines,
    getBankTransactionQuery,
    onLinesSaved,
    sendNotification,
    companyId
  }) => async (lines, attachment, dateState, fullUpdate) => {

    // console.log("76 - lines=", lines);
    // console.log("77 - dateState=", dateState);
    // console.log("78 - fullUpdate=", fullUpdate);

    const bankTransaction = _.cloneDeep(
      getBankTransactionQuery.bankTransaction
    );
    const formerLines = _.cloneDeep(bankTransaction.bankTransactionLines);
    let errorLines = [];

    // console.log("82 - >> >> bankTransaction", bankTransaction);
    if (
      bankTransaction.amount < 0.0 ||
      bankTransaction.sensTransaction === "DEBIT"
    ) {
      // invert all line amounts
      console.log("Invert lines amount...");

      _.forEach(lines, o => {
        o.amount = -o.amount;
        o.companyCurrencyAmount = -o.companyCurrencyAmount;
      });
    }

    // Check LINE AMOUNT
    _.forEach(lines, o => {
      if (o.amount === 0) {
        console.log("Line=", o);
        errorLines.push(o);
      }
    });
    if (errorLines.length > 0) {
      _.forEach(errorLines, o => {
        let index = lines.indexOf(o);
        lines.splice(index, 1);
      });
    }

    // Check CATEGORY
    errorLines = [];
    _.forEach(lines, o => {
      if (o.categoryId === null || o.categoryId === undefined) {
        let index = lines.indexOf(o);
        errorLines.push(index);
      }
    });
    if (errorLines.length > 0) {
      if (
        bankTransaction.amount < 0.0 ||
        bankTransaction.sensTransaction === "DEBIT"
      ) {
        // invert all line amounts
        console.log("Invert lines amount...");

        _.forEach(lines, o => {
          o.amount = -o.amount;
          o.companyCurrencyAmount = -o.companyCurrencyAmount;
        });
      }

      console.log(" CATEGORY ERROR", errorLines);
      const params = {
        errorLines: errorLines
      };
      throw new InvalidTiersError(params);
    }

    // Check AMOUNTS
    errorLines = [];
    let sumAmounts = bankTransaction.amount;
    _.forEach(lines, o => {
      sumAmounts -= o.amount;
    });
    if (FIXED2(sumAmounts) !== 0) {
      if (
        bankTransaction.amount < 0.0 ||
        bankTransaction.sensTransaction === "DEBIT"
      ) {
        // invert all line amounts
        console.log("Invert lines amount...");

        _.forEach(lines, o => {
          o.amount = -o.amount;
          o.companyCurrencyAmount = -o.companyCurrencyAmount;
        });
      }

      console.log(" AMOUNTS ERROR", FIXED2(sumAmounts));
      const params = {
        amount: FIXED2(sumAmounts)
      };
      throw new InvalidTiersError(params);
    }

    // Check TIERS
    errorLines = [];
    _.forEach(lines, o => {
      if (
        o.categoryIds === "ids_clients" ||
        o.categoryIds === "ids_collaborators" ||
        o.categoryIds === "ids_suppliers"
      ) {
        if (!o.tiersId) {
          let index = lines.indexOf(o);
          errorLines.push(index);
        }
      }
    });
    if (errorLines.length > 0) {
      if (
        bankTransaction.amount < 0.0 ||
        bankTransaction.sensTransaction === "DEBIT"
      ) {
        // invert all line amounts
        console.log("Invert lines amount...");

        _.forEach(lines, o => {
          o.amount = -o.amount;
          o.companyCurrencyAmount = -o.companyCurrencyAmount;
        });
      }

      console.log(" TIERS ERROR");
      const params = {
        errorLines: errorLines
      };
      throw new InvalidTiersError(params);
    }

    const newLines = await linesUpdate(
      "BankTransaction",
      formerLines,
      lines,
      createBankTransactionLines,
      createBankTransactionLinesWithoutTiersId,
      updateBankTransactionLines,
      deleteBankTransactionLines,
      bankTransaction.bankAccount && bankTransaction.bankAccount.id || null
    );

    // console.log("220 - newLines=", newLines);
    // console.log("221 - formerLines=", formerLines);
    // console.log("222 - lines=", lines);

    let someChange = false;
    if (formerLines.length === lines.length) {

      let i = 0;
      for (i = 0; i < formerLines.length; i++) {

        if (lines[i].categoryId) {
          if (
            lines[i].category === null ||
            lines[i].category === undefined ||
            (
              lines[i].category &&
              lines[i].categoryId !== lines[i].category.id
            )
          ) {
            someChange = true;
          }
        }

        if (lines[i].tiersId) {
          if (
            lines[i].tiers === null ||
            lines[i].tiers === undefined ||
            (
              lines[i].tiers &&
              lines[i].tiersId !== lines[i].tiers.id
            )
          ) {
            someChange = true;
          }
        }

        // console.log("246 - lines[i].valueTax=", lines[i].valueTax);
        // console.log("246 - formerLines[i].valueTax=", formerLines[i].valueTax);
        if (
          lines[i].amount !== formerLines[i].amount ||
          lines[i].companyCurrencyAmount !== formerLines[i].companyCurrencyAmount ||
          lines[i].valueTax !== formerLines[i].valueTax
        ) {
          someChange = true;
        }
      };
    } else {
      someChange = true;
    }

    // should connect the attachment if any
    console.log("connect attachment ?");
    if (attachment) {
      bankTransaction.attachment = attachment;
    }

    // console.log("267 - data=", bankTransaction.date);

    if (dateState && bankTransaction.date !== dateState) {
      // console.log("275 - date=", bankTransaction.date, dateState);
      bankTransaction.date = dateState;
      fullUpdate = true;
    }

    if (lines.length === newLines.length) {
      await updateBankTransaction(bankTransaction, fullUpdate);
    }
  }
});

let PaymentAffectation = ({
  getBankTransactionQuery,
  companyId,
  saveLines,
  deleteBankTransaction,
  reQualifyBankTransaction,
  companyDefaultInfos,
  sendNotification,
  createAttachmentMutation,
  deleteBankTransactionAttachmentMutation,
  handleMinimizeSidebar,
  history,
  addEventMutation
}) => {
  const bankTransaction = getBankTransactionQuery.bankTransaction;
  if (getBankTransactionQuery.loading || !bankTransaction) {
    return <Spinner size="lg" fullScreen />;
  }

  bankTransaction.fixedDate = new Date(
    new Date(fixDateFromDataBase(bankTransaction.date)).getTime() +
    0 * 60 * 60 * 1000
  ); // FORCE GMT+2

  console.log("310 - companyDefaultInfos=", companyDefaultInfos);

  return (
    <div>
      <PaymentAffectationForm
        sendNotification={sendNotification}
        companyDefaultInfos={companyDefaultInfos}
        bankTransaction={bankTransaction}
        companyId={companyId}
        saveLines={saveLines}
        deleteBankTransaction={deleteBankTransaction}
        reQualifyBankTransaction={reQualifyBankTransaction}
        createAttachmentMutation={createAttachmentMutation}
        deleteBankTransactionAttachmentMutation={
          deleteBankTransactionAttachmentMutation
        }
        handleMinimizeSidebar={handleMinimizeSidebar}
        history={history}
        addEventMutation={addEventMutation}
      />
    </div>
  );
};

export default compose(
  query,
  createLineMutation,
  createLineMutationWithoutTiersId,
  updateLineMutation,
  deleteLineMutation,
  saveLinesHandler,
  graphql(Queries.createAttachment, {
    name: "createAttachmentMutation"
  }),
  graphql(Queries.addEvent, {
    name: "addEventMutation",
    options: { fetchPolicy: "no-cache" }
  }),
  pure
)(PaymentAffectation);
